import axios from "axios";
import { usersAPI, trailAPI } from "../api";
import { encryptStorage } from "src/Util";

export const TRIAL_USER_INITIATE = 'TRIAL_USER_INITIATE'
export const TRIAL_USER_REGISTER = 'TRIAL_USER_REGISTER'
export const TRIAL_USER_REGISTER_FAIL = 'TRIAL_USER_REGISTER_FAIL'
export const TRIAL_USER_LOGIN = 'TRIAL_USER_LOGIN'
export const TRIAL_USER_ERROR = 'TRIAL_USER_ERROR'
export const TRIAL_USER_VERIFY_LINK = 'TRIAL_USER_VERIFY_LINK'
export const VERIFY_CAPTCHA = 'VERIFY_CAPTCHA'


export const trialUserLogin = (email) => (dispatch) => {
    const detail = {
        email_id:`${email}`
    }
    usersAPI.post('/user/trail/login', detail).then((res)=>{
        if(res.data.status === 'TU_NEW_USER') {
            dispatch({
                type: TRIAL_USER_INITIATE,
                payload: res.data,
            })
        }else if(res.data.status === 'TU_LOGIN_SUCCESSFUL'){
            sessionStorage.setItem('trial-user-authenticated', true)
            sessionStorage.setItem('trial-user-emailId',res.data.data.emailId)
            sessionStorage.setItem('trial-userId',res.data.data.userId)
            sessionStorage.setItem('trial-companyId',res.data.data.company_id)
            dispatch({
                type: TRIAL_USER_LOGIN,
                payload: res.data,
            })
        }else{
            dispatch({
                type: TRIAL_USER_ERROR,
                payload: res.data
            })
        }
    })
}

export const trialUserRegistration = (email, name, designation, company) => (dispatch) => {
    const regDetail = {
        email_id : `${email}`,
        job_title : `${designation}`,
        user_name : `${name}`,
        company_name : `${company}`,
    }
    usersAPI.post('/user/trail/add', regDetail).then((regRes)=>{
        if(regRes.data.status === 'TU_CREATED') {
            dispatch({
                type: TRIAL_USER_REGISTER,
                payload: regRes.data
            })
        } else if (regRes.data.status === 'TU_REGISTRATION_FAILED') {
            dispatch({
                type: TRIAL_USER_REGISTER_FAIL,
                payload: regRes.data
            })
        }
    })
}

export const verifyTrialUser = (linkCode) => (dispatch) => {
    usersAPI.post(`/user/trail/verify?link=${linkCode}`).then((verifyRes)=>{
        if(verifyRes.data.success === true){
            sessionStorage.setItem('trial-user-authenticated', true)
            sessionStorage.setItem('trial-user-emailId',verifyRes.data.data.emailId)
            sessionStorage.setItem('trial-userId',verifyRes.data.data.userId)
            sessionStorage.setItem('trial-companyId',verifyRes.data.data.company_id)
            dispatch({
                type: TRIAL_USER_VERIFY_LINK,
                payload: verifyRes.data
            })
        } else {
            window.location.href="#/trial"
            window.location.reload()
        }
    })
}


export const verifyCaptchaToken = (secretKey, resToken) => (dispatch) => {
    trailAPI.post(`/verifytoken?secret=${secretKey}&response=${resToken}`).then((res)=>{
        console.log('>>>>>res', res)
        dispatch({
            type: VERIFY_CAPTCHA,
            payload: res.data
        })
    })
}